export default __webpack_public_path__ + "static/media/airbnb.1f10f3e9.jpg";